export default __webpack_public_path__ + "static/media/face-mask.877d0890.png";